import { Command } from "@/commands/Command.js"
import { _deepClone } from "nvd-js-helpers/misc";
import { ensureLoggedInForSchemaEdit } from "@/helpers/edit-access";
import { findFieldRenames } from "@/helpers/relationship-references";
import { RelationshipReferenceService } from "@/services/RelationshipReferenceService";

export class UpdateTableCommand extends Command {
    _description = "Edit Table"
    oldData = {}
    referenceChanges = []

    async saveUpdatedTable(data, table) {
        this.updateDbml()
        const schema = ((await import('../stores/schema.store')).useSchemaStore)()
        return await schema.saveTable({
            data,
            saveSilently: true
        }, table)
    }

    async run() {
        if (!ensureLoggedInForSchemaEdit()) return
        const { table, data } = this.payload
        this.oldData = _deepClone(table)
        const fieldRenames = findFieldRenames(this.oldData.fields, data.fields)

        for (const [key, value] of Object.entries(data)) {
            table[key] = value
            if (key === 'checked') {
                table.fields.forEach(field => {
                    field[key] = value
                })
            }
        }

        const references = new RelationshipReferenceService(this.tab)
        this.referenceChanges = references.apply(this.oldData.name, fieldRenames)
        const saveResult = await this.saveUpdatedTable(data, table)
        if (saveResult !== false) {
            await references.save(this.referenceChanges)
        }
        super.run()
        return saveResult
    }

    async undo() {
        const { table } = this.payload
        for (const [key, value] of Object.entries(this.oldData)) {
            table[key] = value
            if (key === 'checked') {
                table.fields.forEach(field => {
                    field[key] = value
                })
            }
        }

        const references = new RelationshipReferenceService(this.tab)
        references.revert(this.referenceChanges)
        await this.saveUpdatedTable(this.oldData, table)
        await references.save(this.referenceChanges)
        super.undo()
    }
}
